export default __webpack_public_path__ + "static/card-5-a741e5f7dd6063eb09ee595a3f9f72ba.png";